import { render, staticRenderFns } from "./com_checkbox.vue?vue&type=template&id=5cc79d58&scoped=true&"
import script from "./com_checkbox.vue?vue&type=script&lang=js&"
export * from "./com_checkbox.vue?vue&type=script&lang=js&"
import style0 from "./com_checkbox.vue?vue&type=style&index=0&id=5cc79d58&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cc79d58",
  null
  
)

export default component.exports